import React from 'react'

import './staggered-values.scss'

import cn from '../../../../commons/src/libs/class-names'

import {CommonProps, Overwrite} from '../../../../commons/src/types'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    values: Array<{left: string | number; right: string | number}>
    divider?: string
  }
>

const StaggeredValues = ({className, values, divider = '≥', ...props}: Props) => (
  <div {...props} className={cn('StaggeredValues', {}, className)}>
    {values &&
      values.map(({left, right}, index) => (
        <React.Fragment key={index}>
          <span className="StaggeredValues__price">{left}</span>
          <span className="StaggeredValues__divider">{divider}</span>
          <span className="StaggeredValues__threshold">{right}</span>
        </React.Fragment>
      ))}
  </div>
)

export default StaggeredValues
